// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"20b621b7","230":"6e540ce8","374":"75e1d925","388":"e4c0a0ea","457":"4a5a5548","583":"d47f4731","634":"540c7e0b","773":"57050387","787":"a4b1ccb2","874":"79d37539","977":"e1fea8a2"}[chunkId] + ".chunk.js";
};